import { SlotRendering } from '@frontend/common-types';
import { Spinner } from '@frontend/components/common';
import { SpotRenderingClient } from '@frontend/spot/api';
import { FormattedMessage } from 'react-intl';

import { SpotLayout } from '../../../spot-rendering';
import { useSelectLocationSpotLayout } from './use-select-location-spot-layout';

export interface SelectLocationSpotLayoutProps {
    spotId: string | null;
    slotId: string | null;
    availableSlotConstraints: Parameters<typeof useSelectLocationSpotLayout>[0]['availableSlotConstraints'];
    setSlotId: (value: string | null) => void;
}

export const SelectLocationSpotLayout = (props: SelectLocationSpotLayoutProps) => {
    const viewProps = useSelectLocationSpotLayout(props);

    if (!props.spotId) {
        return null;
    }

    if (viewProps.isLoadingSpotLayout || !viewProps.selectedSpot || !viewProps.currentAccount) {
        return (
            <div className='border-border-default bg-background-default flex min-h-0 flex-1 items-center justify-center rounded-md border'>
                <Spinner />
            </div>
        );
    }

    return (
        <div className='flex min-h-0 w-full flex-1 flex-col gap-3'>
            <p className='text-foreground-muted shrink-0 text-sm'>
                <FormattedMessage
                    id='platform.wizard-rendering.select-location-spot-layout.legend'
                    description='Legend on wizard location screens explaining how to select a SLOT from the SPOT layout'
                    defaultMessage='Click an available SLOT to select it. Unavailable SLOTs are shown disabled.'
                />
            </p>
            <div className='border-border-default bg-background-default min-h-0 min-w-0 flex-1 overflow-hidden rounded-xl border'>
                <SpotLayout
                    key={viewProps.selectedSpot.id}
                    spot={viewProps.selectedSpot}
                    renderSingleModule
                    className='h-full'
                    fetchSpotData={(arg) => SpotRenderingClient.fetchSpotRendering(viewProps.currentAccount!, viewProps.selectedSpot!.id, arg)}
                    fetchModuleData={SpotRenderingClient.fetchSpotModuleRendering}
                    onSlotClick={viewProps.handleLayoutSlotClick}
                    enableZoom
                    enableZoomControls
                    styles={{
                        getSlotColor: viewProps.getLayoutSlotColor,
                        isSlotDisabled: viewProps.isLayoutSlotDisabled
                    }}
                    slot={{
                        renderElement: (slot: SlotRendering) => (
                            <div className='text-background-surface pointer-events-none absolute bottom-0 left-0 pb-1 pl-2 text-xs font-semibold select-none'>
                                {viewProps.getSlotLabel(slot)}
                            </div>
                        )
                    }}
                />
            </div>
        </div>
    );
};
